module.exports = __webpack_public_path__ + "img/1.1d10fe48.png";